import React, { useEffect, useState } from "react";
import { Button, Modal, TextField, makeStyles } from "@material-ui/core";
import { InputWithAutoComplete } from "@carrier-ecat/ngecat-reactcomponents";
import { height } from "@fortawesome/free-solid-svg-icons/faSave";
import WarningPopup from "../../components/common/controls/warningPopup";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import { constants } from "../../constants/constants";
import _ from "lodash";

const useStyles = makeStyles((theme) => {
  return {
    paper: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      position: "absolute",
      width: 400,
      borderRadius: "5px",
    },
    buttonContainer: {
      display: "flex",
      textAlign: "right",
      gap: "20px",
      marginTop: "40px",
    },
    fieldHeight: {
      height: "40px",
    },
    saveButton: {
      minWidth: "150px",
      padding: "10px",
      backgroundColor: "#0e3b8d",
      color: "white",
      border: "none",
      borderRadius: "5px",
      fontSize: "16px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    },
    cancelbutton: {
      width: "150px",
      padding: "10px",
      backgroundColor: "#fff",
      color: "#000",
      border: "1px solid #000",
      borderRadius: "5px",
      fontSize: "16px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      marginLeft: "auto",
    },
  };
});

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const AddNewDrawingModal = ({
  open = false,
  onClose,
  selectedModel = "",
  views = [],
  drawingsOptions = [],
  onCreate,
  fetchUploadedDrawings,
  intl
}) => {
  const classes = useStyles();
  const [selectedView, setSelectedView] = useState("");
  const [drawingName, setDrawingName] = useState("");
  const [pageNumber, setPageNumber] = useState("");
  const [pageLabel, setPageLabel] = useState("");
  const [pageDescription, setPageDescription] = useState("");
  const [drawing, setDrawing] = useState([]);

  const options = _.sortBy(views, "sort").map((view) => ({
    title: injectIntlTranslation(intl, view.viewName, view.viewName),
    viewId: view.viewId,
  }));

  useEffect(() => {
    if (open) fetchUploadedDrawings();
  }, [open]);

  useEffect(() => {
    if (drawingsOptions.length) {
      setDrawing(drawingsOptions);
    }
  }, [drawingsOptions]);

  const onCreateClick = () => {
    onCreate({
      drawingName,
      selectedView,
      selectedModel,
      pageNumber,
      pageLabel,
      pageDescription,
    });
    onClose();
  };

  const handleChange = (_, value) => {
    setSelectedView(value);
  };

  return (
    <WarningPopup
      width={"550px"}
      open={open}
      onClose={onClose}
      title={injectIntlTranslation(intl, "addNewRecord" , constants.addNewRecord)}
      description={
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <InputWithAutoComplete
            options={_.sortBy(drawing, "title")}
            onChange={(_, value) => {
              setDrawingName(value?.viewId || "");
            }}
            outlined
            label={injectIntlTranslation(intl, "selectDrawing" , constants.selectDrawing)}
          />

          <InputWithAutoComplete
            options={options}
            onChange={handleChange}
            outlined
            label={injectIntlTranslation(intl, "selectView" , constants.selectView)}
          />

          <TextField
            id="outlined-basic-pageNumber"
            label={injectIntlTranslation(intl, "pageNumber" , constants.pageNumber)}
            variant="outlined"
            type="number"
            value={pageNumber}
            onChange={(e) => setPageNumber(e.target.value)}
          />
          <TextField
            id="outlined-basic-pageLabel"
            label={injectIntlTranslation(intl, "pageLabel" , constants.pageLabel)}
            variant="outlined"
            value={pageLabel}
            onChange={(e) => setPageLabel(e.target.value)}
          />
          <TextField
            id="outlined-basic-pageDescription"
            label={injectIntlTranslation(intl, "pageDescription" , constants.pageDescription)}
            variant="outlined"
            value={pageDescription}
            multiline
            rowsMax={4}
            rows={4}
            onChange={(e) => setPageDescription(e.target.value)}
          />

          <div className={classes.buttonContainer}>
            <Button
              variant="outlined"
              onClick={onClose}
              className={classes.cancelbutton}
            >
              {injectIntlTranslation(intl, "cancelBtnLabel" , constants.cancelBtnLabel)}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={onCreateClick}
              disabled={!drawingName || !selectedView || !selectedModel}
              className={classes.saveButton}
            >
              {injectIntlTranslation(intl, "addRecord" , constants.addRecord)}
            </Button>
          </div>
        </div>
      }
      hideBtn={true}
    />
  );
};

export default injectIntl(AddNewDrawingModal);
